module.exports = __webpack_public_path__ + "img/18pornLogo.71e81472.png";